import React, { useEffect, useRef, useState } from "react";
import {
  makeStyles,
  Typography,
  Box,
  Grid,
  Button,
  Select,
  Divider,
  useMediaQuery,
  InputLabel,
  Checkbox,
  FormControlLabel,
  FormControl,
  TextField,
  MenuItem,
  RadioGroup,
  Radio,
  FormLabel,
  useTheme,
  Container,
  Tabs,
  Tab,
  IconButton,
  ButtonBase,
  CircularProgress,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useLocation, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import Pagination from "@material-ui/lab/Pagination";
import SwipeableViews from "react-swipeable-views";
import moment from "moment";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import SearchIcon from "@material-ui/icons/Search";
import RepeatIcon from "@material-ui/icons/Repeat";

import divisions from "../divisions.json";
import { propertyDataArray } from "../components/PropertyDataArray";
import { searchDataArray } from "./../components/searchDataArray";
import Table from "../components/Table";
import { useAlert } from "../components/Alert";
import Text from "../components/Text";
import ChoiceProperty from "./ChoiceProperty";
import SearchPropertyResult from "./SearchPropertyResult";

export default function SearchPage() {
  const history = useHistory();
  const searchType = new URLSearchParams(useLocation().search);
  const [search, setSearch] = useState(false);
  const [searchData, setSearchData] = useState();
  const props = {
    search,
    setSearch,
    searchData,
    setSearchData,
  };
  // 按下搜尋按鍵後回傳 true
  useEffect(() => {
    if (!!history.location.state) {
      setSearchData(history.location.state);
      setSearch(true);
    }
  }, [history.location.state]);

  return (
    <Box>
      {searchType.get("searchType") === "easy" ? (
        <EasySearch props={props} />
      ) : (
        <DetailSearch props={props} />
      )}
      {search ? (
        <SearchPropertyResult data={searchData} searchType={searchType} />
      ) : (
        <ChoiceProperty />
      )}
    </Box>
  );
}

//ANCHOR 簡易查詢
function EasySearch({ props }) {
  const { search, setSearch, searchData, setSearchData } = props;
  let city = Object.keys(divisions);
  const history = useHistory();
  const isPhone5 = useMediaQuery("(max-width:320px)");
  const isPhone = useMediaQuery("(max-width:376px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const [selectDistrict, setSelectDistrict] = useState();
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100%",
      minHeight: "400px",
    },
    backImg: {
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    contentBox: {
      justifyContent: "center",
    },
    selectBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      backgroundColor: "white",
      height: isPhone ? "45px" : isPad ? "55px" : "65px",
      borderRadius: isPhone ? "22px" : isPad ? "30px" : "35px",
      marginBottom: "10px",
    },
    selectGrid: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRight: "1px solid black",
    },
    select: {
      lineHeight: isPhone ? "30px" : isPad ? "25px" : isTable ? "25px" : "30px",
      backgroundColor: "transparent",
      padding: isPhone ? "0px 10px" : "0px 20px",
      fontSize: isPhone ? "0.75rem" : "1rem",
      width: isPhone5
        ? "35px"
        : isPhone
        ? "35px"
        : isPad
        ? "50px"
        : isTable
        ? "75px"
        : "100px",
      height: isPhone ? "30px" : isPad ? "25px" : isTable ? "25px" : "30px",
      textOverflow: "ellipsis",
      "&.MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
    },
    buttonBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "10px",
    },
    button: {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
      width: isPhone ? "170px" : isPad ? "200px" : isTable ? "250px" : "270px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    change: {
      color: theme.palette.secondary.light,
      margin: "10px 0px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
    },
    checkBox: {
      color: "lightgrayblue",
      marginLeft: "15px",
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
      },
      "&:not($checked) .MuiIconButton-label:after": {
        content: '""',
        left: 5,
        top: 5,
        height: "20px",
        width: "20px",
        position: "absolute",
        backgroundColor: "white",
        zIndex: -1,
      },
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: theme.palette.primary.main,
      },
      "& .MuiSvgIcon-root": {
        height: "30px",
        width: "30px",
      },
    },
  }));
  const classes = useStyles();

  const { typeArray } = searchDataArray();

  const [type, setType] = useState(["土地", "建物"]);

  const typeChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "全選") {
      setType(type.length === typeArray.length ? [] : typeArray);
      return;
    }
    setType(value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // 簡易查詢按鈕 submit

  useEffect(() => {
    if (!!history.location.state) {
      setValue("district", history.location.state.district);

      Object.keys(divisions).map((item, index) => {
        if (divisions[city[index]].zhTW === history.location.state.district) {
          setSelectDistrict(divisions[city[index]].subdivisions);
        }
      });

      setTimeout(() => {
        setValue("subdistrict", history.location.state.subdistrict);
      }, 0);
    }
  }, [history.location.state]);

  function _submit(data) {
    setSearchData(data);
    setSearch(true);
  }

  return (
    <Box className={classes.backBox}>
      <img
        src="/assets/images/Home/findBestPlace.png"
        className={classes.backImg}
      />
      <Grid
        container
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: isPhone ? "500px" : isPad ? "600px" : "700px",
        }}
      >
        <Grid container item xs={12} lg={10} className={classes.contentBox}>
          <Grid
            container
            item
            xs={11}
            sm={9}
            md={7}
            lg={7}
            className={classes.selectBox}
          >
            <Grid item xs={3} lg={3} className={classes.selectGrid}>
              <Select
                native
                {...register("district")}
                classes={{ root: classes.select }}
                disableUnderline
                onChange={(e) => {
                  setSelectDistrict(
                    divisions[city[e.target.selectedIndex - 1]].subdivisions
                  );
                }}
              >
                <option disabled selected value="">
                  縣市
                </option>
                {Object.keys(divisions).map((item, index) => (
                  <option key={item}>{divisions[city[index]].zhTW}</option>
                ))}
              </Select>
            </Grid>
            <Grid item xs={3} lg={3} className={classes.selectGrid}>
              <Select
                native
                {...register("subdistrict")}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  鄉鎮/區域
                </option>
                {selectDistrict !== undefined
                  ? Object.keys(selectDistrict)
                      .map((item) => selectDistrict[item].zhTW)
                      .map((item, index) => <option key={item}>{item}</option>)
                  : null}
              </Select>
            </Grid>
            <Grid item xs={3} lg={3} className={classes.selectGrid}>
              <Select
                multiple
                disableUnderline
                {...register("type")}
                onChange={typeChange}
                displayEmpty={true}
                value={type}
                classes={{ root: classes.select }}
                renderValue={
                  type.length === 0
                    ? () => "物件類型"
                    : (selected) => selected.join(", ")
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                }}
              >
                <MenuItem key="全選" value="全選">
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.checkBox}
                        checked={
                          typeArray.length > 0 &&
                          type.length === typeArray.length
                        }
                        indeterminate={
                          type.length > 0 && type.length < typeArray.length
                        }
                      />
                    }
                    label={<Typography variant="subtitle1">全選</Typography>}
                  />
                </MenuItem>
                {typeArray.map((item) => (
                  <MenuItem key={item} value={item}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className={classes.checkBox}
                          checked={type.indexOf(item) > -1}
                        />
                      }
                      label={
                        <Typography variant="subtitle1">{item}</Typography>
                      }
                    />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={12} className={classes.buttonBox}>
            <Button
              className={classes.change}
              startIcon={<RepeatIcon />}
              onClick={() => history.push(`./search?searchType=detail`)}
            >
              切換至詳細查詢
            </Button>
          </Grid>
          <Grid item xs={12} lg={12} className={classes.buttonBox}>
            <Button
              className={classes.button}
              startIcon={<SearchIcon style={{ fontSize: "28px" }} />}
              onClick={handleSubmit(_submit)}
            >
              查詢
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

//ANCHOR 詳細查詢
function DetailSearch({ props }) {
  let city = Object.keys(divisions);
  const { search, setSearch, searchData, setSearchData } = props;
  const history = useHistory();
  const Alert = useAlert();
  const isPhone = useMediaQuery("(max-width:376px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  // const isTable = useMediaQuery("(min-width:769px)");
  // const isPhone = useMediaQuery("(min-width:475px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100%",
      minHeight: "500px",
      marginTop: "56px",
      "& .MuiFormLabel-root": {
        color: "white",
      },
    },
    backImg: {
      position: "absolute",
      objectFit: "cover",
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    title: {
      color: "white",
      margin: "20px 0px",
    },
    select: {
      backgroundColor: "white",
      width: isPhone ? "auto" : "130px",
      minWidth: "100px",
      height: "22px",
      padding: "7px 24px 7px 10px",
      border: "1px solid black",
      borderRadius: "5px",
      "&:focus": {
        backgroundColor: "white",
        borderRadius: "5px",
      },
    },
    checkBox: {
      color: "lightgrayblue",
      marginLeft: "15px",
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
      },
      "&:not($checked) .MuiIconButton-label:after": {
        content: '""',
        left: 5,
        top: 5,
        height: "20px",
        width: "20px",
        position: "absolute",
        backgroundColor: "white",
        zIndex: -1,
      },
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: theme.palette.primary.main,
      },
      "& .MuiSvgIcon-root": {
        height: "30px",
        width: "30px",
      },
    },
    textField: {
      backgroundColor: "white",
      borderRadius: "5px",
      height: "38px",
    },
    radio: {
      display: "flex",
      flexDirection: "row",
      color: "white",
      "& .MuiRadio-colorSecondary.Mui-checked": {
        color: theme.palette.secondary.light,
      },
      "& .MuiIconButton-colorSecondary": {
        color: "white",
      },
    },
    changeButtonBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: isPhone ? "60px 0px 10px 0px" : "30px 0px 10px 0px",
    },
    searchButtonBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: isPad ? "10px 0px 100px 0px" : "10px 0px 200px 0px",
    },
    searchButton: {
      backgroundColor: theme.palette.primary.main,
      color: "white",
      marginRight: "30px",
      width: isPhone ? "170px" : isPad ? "200px" : isTable ? "250px" : "270px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    reSearchButton: {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
      width: isPhone ? "170px" : isPad ? "200px" : isTable ? "250px" : "270px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    change: {
      color: theme.palette.secondary.light,
      margin: "10px 0px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
    },
  }));
  const classes = useStyles();

  const {
    courtArray,
    pageAmountArray,
    typeLand,
    auctionsArray,
    landRightsArray,
    buildRightsArray,
    pointHandArray,
    sourceOfTheCaseArray,
    typeArray,
  } = searchDataArray();

  const [selectDistrict, setSelectDistrict] = useState();
  const [property, setProperty] = useState([]);
  const [type, setType] = useState(["土地", "建物"]);
  const [auctions, setAuctions] = useState([]);
  const auctionsChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "全選") {
      setAuctions(
        auctions.length === auctionsArray.length ? [] : auctionsArray
      );
      return;
    }
    setAuctions(value);
  };

  const propertyChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "全選") {
      setProperty(property.length === typeLand.length ? [] : typeLand);
      return;
    }
    setProperty(value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    control,
  } = useForm();
  // 詳細查詢按紐
  function _submit(data) {
    if (!!localStorage.getItem("@fullhouse-webMemberId")) {
      data.type = type;
      window.scrollTo({
        top: isPhone ? 1100 : 900,
        behavior: "smooth",
      });
      setSearchData(data);
      setSearch(true);
    } else {
      Alert.alert("通知", "請先登入並訂閱後才能使用！", [
        {
          text: "確定",
          onPress: () => {
            history.replace("/log-in");
          },
          type: "ok",
        },
        {
          text: "取消",
          type: "cancel",
        },
      ]);
    }
  }
  return (
    <Grid className={classes.backBox} container justify="center">
      <img
        src="/assets/images/Search/detailSearch.png"
        className={classes.backImg}
      />
      <Grid container item xs={11}>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.title}>
              詳細查詢
            </Typography>
          </Grid>
          {/* ANCHOR 法院  */}
          <Grid item xs={12} style={{ display: "flex", flexWrap: "wrap" }}>
            <Grid item xs={12} sm={4} md={3}>
              <InputLabel shrink>法院</InputLabel>
              <Select
                native
                {...register("court", { required: "請選擇法院" })}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  請選擇法院
                </option>
                {courtArray.map((item) => (
                  <option key={item}>{item}</option>
                ))}
              </Select>
              {errors.court?.type === "required" && (
                <p style={{ color: "red", textAlign: "start" }}>
                  {errors.court.message}
                </p>
              )}
            </Grid>
            {/* <Grid item xs={12} sm={6} style={{ display: "flex" }}>
              <Grid>
                <FormControlLabel
                  control={
                    <Checkbox
                      className={classes.checkBox}
                      {...register("mapMode")}
                    />
                  }
                  label={
                    <Typography variant="subtitle1" style={{ color: "white" }}>
                      地圖模式
                    </Typography>
                  }
                />
              </Grid>
              <Grid>
                <FormControlLabel
                  control={
                    <Checkbox
                      className={classes.checkBox}
                      {...register("auction")}
                    />
                  }
                  label={
                    <Typography variant="subtitle1" style={{ color: "white" }}>
                      拍定行情
                    </Typography>
                  }
                />
              </Grid>
            </Grid> */}
          </Grid>
          {/* ANCHOR 地址  */}
          <Grid item xs={12} style={{ display: "flex", flexWrap: "wrap" }}>
            <Grid xs={6} sm={4} md={isTable ? 3 : 2}>
              <InputLabel shrink>縣市</InputLabel>
              <Select
                native
                {...register("district")}
                classes={{ root: classes.select }}
                disableUnderline
                onChange={(e) => {
                  setSelectDistrict(
                    divisions[city[e.target.selectedIndex - 1]].subdivisions
                  );
                }}
              >
                <option disabled selected value="">
                  縣市
                </option>
                {Object.keys(divisions).map((item, index) => (
                  <option key={item}>{divisions[city[index]].zhTW}</option>
                ))}
              </Select>
            </Grid>
            <Grid
              xs={6}
              sm={4}
              md={isTable ? 9 : 2}
              style={{
                marginLeft: isTable ? "0px" : "10px",
              }}
            >
              <InputLabel shrink>鄉鎮/區域</InputLabel>
              <Select
                native
                {...register("subdistrict")}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  鄉鎮/區域
                </option>
                {selectDistrict !== undefined
                  ? Object.keys(selectDistrict)
                      .map((item) => selectDistrict[item].zhTW)
                      .map((item, index) => <option key={item}>{item}</option>)
                  : null}
              </Select>
            </Grid>
            <Grid
              xs={12}
              sm={5}
              md={3}
              style={{ marginLeft: isTable ? "0px" : "10px" }}
            >
              <InputLabel shrink>地址</InputLabel>
              <TextField
                className={classes.textField}
                fullWidth={isPad ? true : false}
                {...register("address")}
              />
            </Grid>
            {/* <Grid
              xs={12}
              sm={5}
              md={3}
              style={{ marginLeft: isPad ? "0px" : "10px" }}
            >
              <InputLabel shrink>案名</InputLabel>
              <TextField
                className={classes.textField}
                fullWidth={isPad ? true : false}
                {...register("caseName")}
              />
            </Grid> */}
          </Grid>
          {/* ANCHOR 日期  */}
          <Grid
            item
            xs={12}
            style={{
              display: isPad ? "" : "flex",
              flexWrap: "wrap",
              marginTop: "10px",
            }}
          >
            <Grid style={{ display: isPad ? "" : "flex" }}>
              <Grid>
                <InputLabel shrink>投標日</InputLabel>
                <TextField
                  type="date"
                  {...register("saleDateStart")}
                  className={classes.textField}
                  fullWidth={isPad ? true : false}
                  defaultValue={moment(new Date()).format("yyyy-MM-DD")}
                />
              </Grid>
              <Grid
                style={{
                  visibility: isPad ? "hidden" : "visible",
                  color: "white",
                  margin: "auto 10px",
                }}
              >
                __
              </Grid>
              <Grid
                style={{
                  marginTop: "auto",
                  marginRight: isPad ? "0px" : isTable ? "100px" : "20px",
                }}
              >
                <TextField
                  type="date"
                  {...register("saleDateEnd")}
                  className={classes.textField}
                  fullWidth={isPad ? true : false}
                  defaultValue={moment(new Date())
                    .add(3, "months")
                    .format("yyyy-MM-DD")}
                />
              </Grid>
            </Grid>
            <Grid style={{ display: isPad ? "" : "flex" }}>
              <Grid>
                <InputLabel shrink>近日新增</InputLabel>
                <TextField
                  type="date"
                  {...register("recentlyAddedStart")}
                  className={classes.textField}
                  fullWidth={isPad ? true : false}
                />
              </Grid>
              <Grid
                style={{
                  visibility: isPad ? "hidden" : "visible",
                  color: "white",
                  margin: "auto 10px",
                }}
              >
                __
              </Grid>
              <Grid style={{ marginTop: "auto" }}>
                <TextField
                  type="date"
                  {...register("recentlyAddedEnd")}
                  className={classes.textField}
                  fullWidth={isPad ? true : false}
                />
              </Grid>
            </Grid>
            <Grid style={{ marginLeft: "10px" }}>
              <InputLabel shrink>關鍵字搜尋</InputLabel>
              <TextField
                className={classes.textField}
                {...register("keywords")}
              />
            </Grid>
          </Grid>
          <hr style={{ color: "white", margin: "10px 0px" }} />
          {/* ANCHOR 評數  */}
          {/* <Grid
            item
            xs={12}
            style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}
          >
            <Grid style={{ display: "flex" }} item xs={12} sm={5}>
              <Grid>
                <InputLabel shrink>建坪</InputLabel>
                <TextField
                  {...register("jianpingStart")}
                  className={classes.textField}
                />
              </Grid>
              <Grid style={{ color: "white", margin: "auto 10px" }}>__</Grid>
              <Grid style={{ marginTop: "auto" }}>
                <TextField
                  {...register("jianpingEnd")}
                  className={classes.textField}
                />
              </Grid>
              <Grid
                style={{
                  color: "white",
                  margin: "auto 10px 5px 10px",
                  fontSize: "20px",
                }}
              >
                坪
              </Grid>
            </Grid>
            <Grid item xs={12} sm={5} style={{ display: "flex" }}>
              <Grid>
                <InputLabel shrink>地坪</InputLabel>
                <TextField
                  {...register("floorStart")}
                  className={classes.textField}
                />
              </Grid>
              <Grid style={{ color: "white", margin: "auto 10px" }}>__</Grid>
              <Grid style={{ marginTop: "auto" }}>
                <TextField
                  {...register("floorEnd")}
                  className={classes.textField}
                />
              </Grid>
              <Grid
                style={{
                  color: "white",
                  margin: "auto 10px 5px 10px",
                  fontSize: "20px",
                }}
              >
                坪
              </Grid>
            </Grid>
          </Grid> */}
          {/* ANCHOR 評數價錢  */}
          {/* <Grid
            item
            xs={12}
            style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}
          >
            <Grid style={{ display: "flex" }} item xs={12} sm={5}>
              <Grid>
                <InputLabel shrink>建坪單價</InputLabel>
                <TextField
                  {...register("unitPriceJianpingStart")}
                  className={classes.textField}
                />
              </Grid>
              <Grid style={{ color: "white", margin: "auto 10px" }}>__</Grid>
              <Grid style={{ marginTop: "auto" }}>
                <TextField
                  {...register("unitPriceJianpingEnd")}
                  className={classes.textField}
                />
              </Grid>
              <Grid
                style={{
                  color: "white",
                  margin: "auto 10px 5px 10px",
                  fontSize: "20px",
                }}
              >
                萬
              </Grid>
            </Grid>
            <Grid style={{ display: "flex" }} item xs={12} sm={5}>
              <Grid>
                <InputLabel shrink>地坪單價</InputLabel>
                <TextField
                  {...register("unitPriceFloorStart")}
                  className={classes.textField}
                />
              </Grid>
              <Grid style={{ color: "white", margin: "auto 10px" }}>__</Grid>
              <Grid style={{ marginTop: "auto" }}>
                <TextField
                  {...register("unitPriceFloorEnd")}
                  className={classes.textField}
                />
              </Grid>
              <Grid
                style={{
                  color: "white",
                  margin: "auto 10px 5px 10px",
                  fontSize: "20px",
                }}
              >
                萬
              </Grid>
            </Grid>
          </Grid> */}
          {/* ANCHOR 底標價  */}
          {/* <Grid item xs={12} style={{ display: "flex", marginTop: "10px" }}>
            <Grid>
              <InputLabel shrink>底標價</InputLabel>
              <TextField
                {...register("basePriceStart")}
                className={classes.textField}
              />
            </Grid>
            <Grid style={{ color: "white", margin: "auto 10px" }}>__</Grid>
            <Grid style={{ marginTop: "auto" }}>
              <TextField
                {...register("basePriceEnd")}
                className={classes.textField}
              />
            </Grid>
            <Grid
              style={{
                color: "white",
                margin: isPhone ? "auto 30px 5px 10px" : "auto 10px 5px 10px",
                fontSize: "20px",
              }}
            >
              萬
            </Grid>
          </Grid> */}
          {/* <hr style={{ color: "white", margin: "10px 0px" }} /> */}
          {/* ANCHOR 案號  */}
          <Grid item xs={12} style={{ display: "flex", marginTop: "10px" }}>
            <Grid>
              <InputLabel shrink htmlFor="caseNumber">
                案號
              </InputLabel>
              <TextField
                {...register("caseYear")}
                className={classes.textField}
              />
            </Grid>
            <Grid
              style={{
                color: "white",
                margin: "auto 10px 5px 10px",
                fontSize: "20px",
              }}
            >
              年
            </Grid>
            <Grid style={{ marginTop: "auto" }}>
              <TextField
                {...register("caseIdentity")}
                className={classes.textField}
              />
            </Grid>
            <Grid
              style={{
                color: "white",
                margin: "auto 10px 5px 10px",
                fontSize: "20px",
              }}
            >
              字
            </Grid>
            <Grid style={{ marginTop: "auto" }}>
              <TextField
                {...register("caseNumber")}
                className={classes.textField}
              />
            </Grid>
            <Grid
              style={{
                color: "white",
                margin: "auto 10px 5px 10px",
                fontSize: "20px",
              }}
            >
              號
            </Grid>
            <Grid className={classes.radio}>
              <InputLabel
                shrink
                style={{
                  position: "absolute",
                }}
              >
                物件類型
              </InputLabel>
              <FormControlLabel
                value={"全選"}
                style={{ paddingTop: "12px" }}
                control={
                  <Checkbox
                    checked={
                      type.length > 0 && type.length === typeArray.length
                    }
                    onChange={() => {
                      let newType = [];
                      for (let i = 0; i < typeArray.length; i++) {
                        newType.push(typeArray[i]);
                      }
                      type.length === typeArray.length
                        ? setType([])
                        : setType(newType);
                    }}
                  />
                }
                label={"全選"}
              />
              {typeArray.map((item) => (
                <FormControlLabel
                  key={item}
                  style={{ paddingTop: "12px" }}
                  value={item}
                  control={
                    <Checkbox
                      checked={Boolean(type.find((item2) => item2 === item))}
                      onChange={() => {
                        const has = type.find(
                          (selectItem) => selectItem === item
                        );
                        if (has) {
                          setType((e) => e.filter((i) => i !== item));
                        } else {
                          setType((e) => [...e, item]);
                        }
                      }}
                    />
                  }
                  label={item}
                />
              ))}
            </Grid>
          </Grid>
          {/* ANCHOR 物件類別  */}
          <Grid container item className={classes.radio}>
            {/* {type.indexOf("建物") !== -1 && (
              <Select
                multiple
                {...register("typeLand")}
                onChange={propertyChange}
                value={property}
                displayEmpty={true}
                classes={{ root: classes.select }}
                renderValue={
                  property.length === 0
                    ? () => "請選擇"
                    : (selected) => selected.join(", ")
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                }}
              >
                <MenuItem key="全選" value="全選">
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.checkBox}
                        checked={
                          typeLand.length > 0 &&
                          property.length === typeLand.length
                        }
                        indeterminate={
                          property.length > 0 &&
                          property.length < typeLand.length
                        }
                      />
                    }
                    label={<Typography variant="subtitle1">全選</Typography>}
                  />
                </MenuItem>
                {typeLand.map((item) => (
                  <MenuItem key={item} value={item}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className={classes.checkBox}
                          checked={property.indexOf(item) > -1}
                        />
                      }
                      label={
                        <Typography variant="subtitle1">{item}</Typography>
                      }
                    />
                  </MenuItem>
                ))}
              </Select>
            )} */}
          </Grid>
          <hr style={{ color: "white", margin: "10px 0px" }} />
          {/* ANCHOR 拍次  */}
          {/* <Grid item xs={12} style={{ display: "flex", marginTop: "10px" }}>
            <Grid>
              <InputLabel shrink>拍次</InputLabel>
              <Select
                multiple
                {...register("auctions")}
                onChange={auctionsChange}
                value={auctions}
                classes={{ root: classes.select }}
                displayEmpty={true}
                renderValue={
                  auctions.length === 0
                    ? () => "請選擇"
                    : (selected) => selected.join(", ")
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                }}
              >
                <MenuItem key="全選" value="全選">
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.checkBox}
                        checked={
                          auctionsArray.length > 0 &&
                          auctions.length === auctionsArray.length
                        }
                        indeterminate={
                          auctions.length > 0 &&
                          auctions.length < auctionsArray.length
                        }
                      />
                    }
                    label={<Typography variant="subtitle1">全選</Typography>}
                  />
                </MenuItem>
                {auctionsArray.map((item) => (
                  <MenuItem key={item} value={item}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className={classes.checkBox}
                          checked={auctions.indexOf(item) > -1}
                        />
                      }
                      label={
                        <Typography variant="subtitle1">{item}</Typography>
                      }
                    />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid> */}
          {/* ANCHOR 土地權利範圍  */}
          <Grid
            item
            xs={12}
            style={{ display: "flex", marginTop: "10px", flexWrap: "wrap" }}
          >
            {/* <Grid>
              <InputLabel shrink>土地權利範圍</InputLabel>
              <Select
                native
                {...register("landRights")}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  請選擇
                </option>
                {landRightsArray.map((item) => (
                  <option key={item}>{item}</option>
                ))}
              </Select>
            </Grid>
            <Grid style={{ marginLeft: "10px" }}>
              <InputLabel shrink>建物權利範圍</InputLabel>
              <Select
                native
                {...register("buildRights")}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  請選擇
                </option>
                {buildRightsArray.map((item) => (
                  <option key={item}>{item}</option>
                ))}
              </Select>
            </Grid> */}
            <Grid>
              <InputLabel shrink>是否點交</InputLabel>
              <Select
                native
                {...register("pointHand")}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  請選擇
                </option>
                {pointHandArray.map((item) => (
                  <option key={item}>{item}</option>
                ))}
              </Select>
            </Grid>
          </Grid>
          {/* ANCHOR 物件來源  */}
          {/* <Grid item xs={12} style={{ display: "flex", marginTop: "10px" }}>
            <Grid>
              <InputLabel shrink>物件來源</InputLabel>
              <Select
                native
                {...register("sourceOfTheCase")}
                classes={{ root: classes.select }}
                disableUnderline
              >
                <option disabled selected value="">
                  請選擇
                </option>
                {sourceOfTheCaseArray.map((item) => (
                  <option key={item}>{item}</option>
                ))}
              </Select>
            </Grid>
          </Grid> */}
          {/* ANCHOR 排序  */}
          <Grid item xs={12} style={{ display: "flex", marginTop: "10px" }}>
            <Grid>
              <FormLabel shrink>排序</FormLabel>
              <Controller
                control={control}
                name="sequence"
                render={({ field: { onChange, value } }) => (
                  <RadioGroup
                    value={value ? value : "投標日"}
                    onChange={onChange}
                    className={classes.radio}
                  >
                    <FormControlLabel
                      value="投標日"
                      control={<Radio />}
                      label="投標日"
                    />
                    <FormControlLabel
                      value="案號"
                      control={<Radio />}
                      label="案號"
                    />
                    <FormControlLabel
                      value="拍次"
                      control={<Radio />}
                      label="拍次"
                    />
                    <FormControlLabel
                      value="底標價"
                      control={<Radio />}
                      label="底標價"
                    />
                  </RadioGroup>
                )}
              />
            </Grid>
          </Grid>
          {/* ANCHOR 查詢按鈕  */}
          <Grid item lg={12} className={classes.changeButtonBox}>
            <Button
              className={classes.change}
              startIcon={<RepeatIcon />}
              onClick={() => history.push(`./search?searchType=easy`)}
            >
              切換至簡單查詢
            </Button>
          </Grid>
          <Grid item lg={12} className={classes.searchButtonBox}>
            <Button
              className={classes.searchButton}
              onClick={handleSubmit(_submit)}
            >
              查詢資料
            </Button>
            <Button
              className={classes.reSearchButton}
              // onClick={handleSubmit(_submit)}
              onClick={() => window.location.reload()}
            >
              重新查詢
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function TabPanel(props) {
  const { children, value, index } = props;
  return <div>{value === index && <Box p={3}>{children}</Box>}</div>;
}
